
import * as kikRuntime$fPiwrZUNFUsNfyh7iJPpJfJ_45vjG_45FVRw4ybn7H_45Plpw from '/builds/shop22/kik-storefront-monorepo/storefront/providers/kik.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "teaser": {
      "modifiers": {
        "format": "jpg",
        "width": 225,
        "height": 269
      }
    },
    "plp": {
      "modifiers": {
        "format": "jpg",
        "width": 445,
        "height": 532
      }
    },
    "pdp": {
      "modifiers": {
        "format": "jpg",
        "width": 834,
        "height": 998
      }
    },
    "pdpThumb": {
      "modifiers": {
        "format": "jpg",
        "width": 92,
        "height": 112
      }
    },
    "cartPreview": {
      "modifiers": {
        "format": "jpg",
        "width": 146,
        "height": 175
      }
    }
  },
  "provider": "kik",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['kik']: { provider: kikRuntime$fPiwrZUNFUsNfyh7iJPpJfJ_45vjG_45FVRw4ybn7H_45Plpw, defaults: {"imageFormat":{"from":["jpeg","jpg","png"],"to":"webp"}} }
}
        